import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { TranslatableDropdownOption } from '../../../core/models';
import { HintDialogService } from '../../../core/services';
import { isNullOrEmpty } from '../../../core/utils/common-functions';
import { BaseComponent } from '../../../shared/components/base.component';

@Component({
  selector: 'sigv-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss'],
})
export class InputSelectComponent extends BaseComponent implements OnInit {
  /** 如有設定則會顯示於 formValidate時的錯誤訊息 */
  @Input() fieldName?: string;
  /** 欲綁定formControl欄位名稱
   * @description useForm.controls['externalName']
   */
  @Input() bindingFormControl?: AbstractControl | any;
  /** 空值欲設提示 */
  @Input() placeholder?: string;
  /** 下拉選單選項 */
  @Input() selectOptions: TranslatableDropdownOption[] | SelectItem[] = [];
  /** 頁面是否純檢視*/
  @Input() isReadOnly: boolean = false;
  /**是否使用於可編輯表格內 */
  @Input() isUseInTable: boolean = false;
  /**是否有階層 */
  @Input() isLayer: boolean = false;
  /** 父階層formControl欄位名稱
   * @description useForm.controls['externalName']
   */
  @Input() parentFormControl?: AbstractControl | any;
  @Input() changeConfirm: boolean = false;
  @Input() changeConfirmColumnName: string = '';
  @Input() changeConfirmMessge: string = '';
  /**
   * 選定選項placeholder呈現紅字
   */
  @Input() isShowRedSelectedItem: boolean = false;
  /**
   * 強制取消顯示清空按鈕
   */
  @Input() forceCloseCleaner: boolean = false;
  /**變動事件 */
  @Output() onChange = new EventEmitter<void>();
  /**變動事件 父層變動的時候子層要在這邊再call一次service*/
  @Output() onParentChange = new EventEmitter<void>();

  useStyle = '';
  parentValue = '';
  beforeValue = '';

  constructor(
    private injector: Injector,
    private hintDialogService: HintDialogService
  ) {
    super(injector);
    this.useStyle = this.isUseInTable ? 'table-dropdown' : '';
  }
  onChangeEvent(event: any): void {
    // 需要檢核異動且異動前有值
    if (this.changeConfirm) {
      this.confirm(event);
    } else {
      this.onChange.emit(event);
    }
  }
  onParentChangeEvent(event: any): void {
    this.onParentChange.emit(event);
  }
  ngOnInit() {
    if (this.isLayer == true) {
      this.setDisabled(true);
      this.onSubscribeValue();
    } else {
    }
    if (this.changeConfirm) {
      this.beforeValue = this.bindingFormControl.value;
    }
  }
  onSubscribeValue(): void {
    this.parentFormControl?.valueChanges.subscribe((value: any) => {
      if (this.parentValue != value) {
        this.onParentChange.emit(value);
        this.setDisabled(false);
      }
      if (value == undefined || value == '') {
        this.setDisabled(true);
      }
      this.parentValue = value;
    });
  }

  setDisabled(status: boolean) {
    const useStatus = status ? 'disable' : 'enable';
    setTimeout(() => {
      this.bindingFormControl[useStatus]();
    }, 100);
  }

  /** 異動確認 */
  confirm(event: any) {
    if (this.beforeValue) {
      // 取得訊息內容並替換欄位名稱
      const str = !isNullOrEmpty(this.changeConfirmMessge)
        ? this.translateService.instant(this.changeConfirmMessge)
        : this.getMessageUtils().messageTranslate(
            'InputSelectChangeConfirm',
            '{{columnName}}',
            this.translateService.instant(this.changeConfirmColumnName)
          );
      this.hintDialogService.showConfirmHint(
        str,
        () => {
          this.doChange(event);
        },
        () => {
          this.bindingFormControl.setValue(this.beforeValue);
        }
      );
    } else {
      this.doChange(event);
    }
  }

  /** 確認異動 */
  doChange(event: any) {
    this.onChange.emit(event);
    this.beforeValue = this.bindingFormControl.value;
  }
}
